module.exports = __webpack_public_path__ + "images/pharosff7e492086dbf5e6d3c76979699b28f5.png";